<template>
  <div class="nuttrema-panel-group-and-sort">
    <div class="nuttrema-panel-group-and-sort__label">
      <slot name="label"></slot>
    </div>
    <div class="nuttrema-panel-group-and-sort__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-panel-group-and-sort',
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .nuttrema-panel-group-and-sort {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: stretch;

    &.is-right-aligned {
      align-items: flex-end;
    }

    &.is-horizontal {
      flex-direction: row;
      align-items: center;
      .nuttrema-panel-group-and-sort__label > h4 {
        margin-right: 0.75em;
        padding: 0;
      }
    }

    &.is-centered {
      .nuttrema-panel-group-and-sort__label, .nuttrema-panel-group-and-sort__content {
        > * {
          width: 100%;
          text-align: center;
        }
      }
    }

    .nuttrema-panel-group-and-sort__label {
      display: flex;
      align-items: center;
      > h4 {
        padding: 0 0.5em;
        font-size: 0.85rem;
        &.no-padding {
          padding: 0;
        }
        &.center {
          text-align: center;
          width: 100%;
        }
        &.is-uppercase {
          font-size: 0.8rem;
          text-transform: uppercase;
        }
        &.is-gray {
          color: $gray;
        }
      }
    }

    .nuttrema-panel-group-and-sort__content {
      flex-grow: 1;
      display: flex;
      > * {
        &.content--title {
          line-height: 1;
          font-weight: 500;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-panel-group-and-sort.vue